import React, { FC, memo } from 'react';
import { DivTitle } from '../../../styles';
import { Field } from 'formik';
import { COLORGATE_CONFIGURATION_TITLES, ColorgateConfigurationFields } from '../../../constants';
import DropdownField from '../../FormComponents/DropdownFiled';
import { TColorgateConfigurationOptions } from '../../../types';
import NumberFormatField from '../../FormComponents/NumberFormatField';

type TProps = {
  options: TColorgateConfigurationOptions;
};

const ColorBlock: FC<TProps> = ({ options }) => {
  return (
    <>
      <DivTitle>Color</DivTitle>
      <Field name={ColorgateConfigurationFields.ColorCorrection}>
        {({ field, form }) => (
          <NumberFormatField
            name={field.name}
            title={COLORGATE_CONFIGURATION_TITLES.colorCorrection}
            placeholder="Enter number 0-100"
            value={field.value}
            maxValue={100}
            suffix="%"
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
      <Field name={ColorgateConfigurationFields.SaturationEnhancement}>
        {({ field, form }) => (
          <DropdownField
            name={field.name}
            options={options[ColorgateConfigurationFields.SaturationEnhancement]}
            title={COLORGATE_CONFIGURATION_TITLES.saturationEnhancement}
            value={field.value}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
    </>
  );
};

export default memo(ColorBlock);
